import { HeaderCellProps } from '../types';

export const TeamTagsHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Tags</div>;
};
